import axios from "axios";
import {getReturnsGrid, getPerfCalendarYrs, getTrailingPerf, getCalYrsVsBM, getStatSummary, getDDHistoryVsBM, getCumulativeReturnsChart, getreturnschart, getDistReturnsChart, getRollingExcessReturns} from "../../config/apiConfig";
import {
  FETCH_RETURNSGRID_DATA_BEGIN,
  FETCH_RETURNSGRID_DATA_SUCCESS,
  FETCH_RETURNSGRID_DATA_FAILURE,
  FETCH_PERFORMANCECALENDARYEARS_DATA_BEGIN,
  FETCH_PERFORMANCECALENDARYEARS_DATA_SUCCESS,
  FETCH_PERFORMANCECALENDARYEARS_DATA_FAILURE,
  FETCH_TRAILINGPERFORMANCE_DATA_BEGIN,
  FETCH_TRAILINGPERFORMANCE_DATA_SUCCESS,
  FETCH_TRAILINGPERFORMANCE_DATA_FAILURE,
  FETCH_VSBMCALYRS_DATA_BEGIN,
  FETCH_VSBMCALYRS_DATA_SUCCESS,
  FETCH_VSBMCALYRS_DATA_FAILURE,

  FETCH_STATSUMMARY_DATA_BEGIN,
  FETCH_STATSUMMARY_DATA_SUCCESS,
  FETCH_STATSUMMARY_DATA_FAILURE,

  FETCH_BMSTATSUMMARYROR_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYSTDDEV_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYSHARPE_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYSORTINO_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYMAXDRAWDOWN_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYCORRELATION_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYBETA_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYALPHA_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYUPCAPTURE_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYDOWNCAPTURE_DATA_SUCCESS,
  FETCH_BMSTATSUMMARYUPDOWNCAPTURE_DATA_SUCCESS,
  FETCH_BMSTATSUMMARY_DATA_FAILURE,
  FETCH_BMDDHistory_DATA_BEGIN,
  FETCH_BMDDHistory_DATA_SUCCESS,
  FETCH_BMDDHistory_DATA_FAILURE,
  FETCH_CUMMCHART_DATA_BEGIN,
  FETCH_CUMMCHART_DATA_FAILURE,
  FETCH_CUMMCHART_DATA_SUCCESS,
  FETCH_VAMICHART_DATA_BEGIN,
  FETCH_VAMICHART_DATA_SUCCESS,
  FETCH_VAMICHART_DATA_FAILURE,
  FETCH_ROLLINGCHART_DATA_BEGIN,
  FETCH_ROLLINGCHART_DATA_SUCCESS,
  FETCH_ROLLINGCHART_DATA_FAILURE,
  FETCH_DISTRCHART_DATA_BEGIN,
  FETCH_DISTRCHART_DATA_SUCCESS,
  FETCH_DISTRCHART_DATA_FAILURE
  } from '../constants/returnsandstatistics';
import { sbaAxios } from "../utils/sbaAxios";
import { StatChoice } from "../../config/statSummaryConfig"




//Returns Grid Data 
export const getReturnsGridDataAction = (entityId, entityType, startDate, endDate, opt) => {
  return (dispatch) => {
    dispatch(getReturnsGridDataActionBegin());
    sbaAxios({ url: `${getReturnsGrid}${entityId},${entityType},${startDate},${endDate},${opt}`, method: 'get' })
      .then((repos) => {
        const ReturnsGridData = repos;
        dispatch(getReturnsGridDataActionSuccess(ReturnsGridData));
      })
      .catch((error) =>
      {
       dispatch(getReturnsGridDataActionFailure(error));
      })
      
  };
}

const getReturnsGridDataActionBegin=()=>({
  type: FETCH_RETURNSGRID_DATA_BEGIN
})

const getReturnsGridDataActionSuccess=(ReturnsGridData)=>({
  type: FETCH_RETURNSGRID_DATA_SUCCESS,
  payload:{ReturnsGridData}
})

const getReturnsGridDataActionFailure=(error)=>({
  type: FETCH_RETURNSGRID_DATA_FAILURE,
  payload:{error}
})

export const getPerfCalendarYrsDataAction=(entityId, entityType, startDate, endDate, opt)=>{
  return (dispatch) => {
    dispatch(getPerfCalendarYrsDataActionBegin());
    sbaAxios({ url: `${getPerfCalendarYrs}${entityId},${entityType},${startDate},${endDate},${opt}`, method: 'get' })
      .then((repos) => {
        const PerformanceCalendarYearsData = repos;
        dispatch(getPerfCalendarYrsDataActionSuccess(PerformanceCalendarYearsData));
      })
      .catch((error) => dispatch(getPerfCalendarYrsDataActionFailure(error)));
  };
}

const getPerfCalendarYrsDataActionBegin=()=>({
  type: FETCH_PERFORMANCECALENDARYEARS_DATA_BEGIN
})

const getPerfCalendarYrsDataActionSuccess=(PerformanceCalendarYearsData)=>({
  type: FETCH_PERFORMANCECALENDARYEARS_DATA_SUCCESS,
  payload:{PerformanceCalendarYearsData}
})

const getPerfCalendarYrsDataActionFailure=(error)=>({
  type: FETCH_PERFORMANCECALENDARYEARS_DATA_FAILURE,
  payload:{error}
})

export const getTrailingPerfDataAction = (entityId, entityType, startDate, endDate, opt) => {
  return (dispatch) => {
    dispatch(getTrailingPerfDataActionBegin());
    sbaAxios({ url: `${getTrailingPerf}${entityId},${entityType},${startDate},${endDate},${opt}`, method: 'get' })
      .then((repos) => {
        const TrailingPerformanceData = repos;
        dispatch(getTrailingPerfDataActionSuccess(TrailingPerformanceData));

      })
      .catch((error) => dispatch(getTrailingPerfDataActionFailure(error)));
  };
}

const getTrailingPerfDataActionBegin=()=>({
  type: FETCH_TRAILINGPERFORMANCE_DATA_BEGIN
})

const getTrailingPerfDataActionSuccess=(TrailingPerformanceData)=>({
  type: FETCH_TRAILINGPERFORMANCE_DATA_SUCCESS,
  payload:{TrailingPerformanceData}
})

const getTrailingPerfDataActionFailure=(error)=>({
  type: FETCH_TRAILINGPERFORMANCE_DATA_FAILURE,
  payload:{error}
})

export const getCalYrsVsBMDataAction=(entityId, entityType, startDate, endDate, opt)=>{
  return async (dispatch) => {
    dispatch(getCalYrsVsBMDataActionBegin());
    sbaAxios({url:`${getCalYrsVsBM}${entityId},${entityType},${startDate},${endDate},${opt}`,method:'get'}).then(response=>{
      const VsBMCalyrsData = response;
      dispatch(getCalYrsVsBMDataActionSuccess(VsBMCalyrsData));
    }).catch(error=>{   
      if(error)  {
        dispatch(getCalYrsVsBMDataActionSuccess({}));     
      }
    })
  };
}

const getCalYrsVsBMDataActionBegin=()=>({
  type: FETCH_VSBMCALYRS_DATA_BEGIN
})

const getCalYrsVsBMDataActionSuccess=(VsBMCalyrsData)=>({
  type: FETCH_VSBMCALYRS_DATA_SUCCESS,
  payload:{VsBMCalyrsData}
})

const getCalYrsVsBMDataActionFailure=(error)=>({
  type: FETCH_VSBMCALYRS_DATA_FAILURE,
  payload:{error}
})

// export const getSummaryTabDataAction = (entityId, entityType, startDate, endDate, opt, statChoices) => {
//   return (dispatch) => {
//     dispatch(getStatSummaryDataActionBegin());
//     Object.values(StatChoice).forEach((statChoice) => {
//     try {
//       const response = sbaAxios({
//         url: `${getStatSummary}${entityId},${entityType},${startDate},${endDate},${opt},${statChoice}`,
//         method: 'get'
//       });

//       const SummaryTabData = response;

//       if (StatChoice.Ror === statChoice) {
//         dispatch(getStatSummaryRorDataActionSuccess(SummaryTabData));
//       } 
//       else if(StatChoice.StandardDeviation === statChoice) {
//         dispatch(getStatSummaryStdDevDataActionSuccess(SummaryTabData));
//       }
//       else if(StatChoice.SharpeRatio === statChoice) {
//         dispatch(getStatSummarySharpeDataActionSuccess(SummaryTabData));
//       }
//       else if(StatChoice.SortinoRatio === statChoice) {
//         dispatch(getStatSummarySortinoDataActionSuccess(SummaryTabData));
//       }
//       else if(StatChoice.MaxDrawdown === statChoice) {
//         dispatch(getStatSummaryMaxDrawdownDataActionSuccess(SummaryTabData));
//       }
//       else if(StatChoice.Correlation === statChoice) {
//         dispatch(getStatSummaryCorrelationDataActionSuccess(SummaryTabData));
//       }    
//       else if(StatChoice.Beta === statChoice) {
//         dispatch(getStatSummaryBetaDataActionSuccess(SummaryTabData));
//       }
//       else if(StatChoice.Alpha === statChoice) {
//         dispatch(getStatSummaryAlphaDataActionSuccess(SummaryTabData));
//       }
//       else if(StatChoice.UpCaptureRatio === statChoice) {
//         dispatch(getStatSummaryUpCaptureDataActionSuccess(SummaryTabData));
//       }
//       else if(StatChoice.DownCaptureRatio === statChoice) {
//         dispatch(getStatSummaryDownCaptureDataActionSuccess(SummaryTabData));
//       }
//       else if(StatChoice.UpDownCaptureRatio === statChoice) {
//         dispatch(getStatSummaryUpDownCaptureDataActionSuccess(SummaryTabData));
//       }      
//     } catch (error) {
//       if (error.message === 'Network Error') {
//         dispatch(tabFailure[statChoice]);
//       } else {
//         dispatch(getStatSummaryDataActionFailure(error));
//       }
//     }
//   });
//   dispatch(getStatSummaryDataActionSuccess());
//   };
// };

export const getSummaryTabDataAction = (entityId, entityType, startDate, endDate, opt, statChoices) => {
  return async (dispatch) => {
    dispatch(getStatSummaryDataActionBegin());

    // const promises = Object.values(StatChoice).map(async (statChoice) => {
      try {
        const response = await sbaAxios({
          url: `${getStatSummary}${entityId},${entityType},${startDate},${endDate},${opt},${99}`,
          method: 'get'
        });

        const SummaryTabData = response;

        
         return SummaryTabData;
      } catch (error) {
        
        return null; 
      }
   

    
  };
};

const getStatSummaryDataActionBegin=()=>({
  type: FETCH_STATSUMMARY_DATA_BEGIN
})
const getStatSummaryDataActionSuccess=()=>({
  type: FETCH_STATSUMMARY_DATA_SUCCESS
})

const getStatSummaryRorDataActionSuccess=(BMStatSummaryRorData)=>({
  type: FETCH_BMSTATSUMMARYROR_DATA_SUCCESS,
  payload:{BMStatSummaryRorData}
})

const getStatSummaryStdDevDataActionSuccess=(BMStatSummaryStdDevData)=>({
  type: FETCH_BMSTATSUMMARYSTDDEV_DATA_SUCCESS,
  payload:{BMStatSummaryStdDevData}
})

const getStatSummarySharpeDataActionSuccess=(BMStatSummarySharpeData)=>({
  type: FETCH_BMSTATSUMMARYSHARPE_DATA_SUCCESS,
  payload:{BMStatSummarySharpeData}
})

const getStatSummarySortinoDataActionSuccess=(BMStatSummarySortinoData)=>({
  type: FETCH_BMSTATSUMMARYSORTINO_DATA_SUCCESS,
  payload:{BMStatSummarySortinoData}
})

const getStatSummaryCorrelationDataActionSuccess=(BMStatSummaryCorrelationData)=>({
  type: FETCH_BMSTATSUMMARYCORRELATION_DATA_SUCCESS,
  payload:{BMStatSummaryCorrelationData}
})

const getStatSummaryMaxDrawdownDataActionSuccess=(BMStatSummaryMaxDrawdownData)=>({
  type: FETCH_BMSTATSUMMARYMAXDRAWDOWN_DATA_SUCCESS,
  payload:{BMStatSummaryMaxDrawdownData}
})

const getStatSummaryBetaDataActionSuccess=(BMStatSummaryBetaData)=>({
  type: FETCH_BMSTATSUMMARYBETA_DATA_SUCCESS,
  payload:{BMStatSummaryBetaData}
})

const getStatSummaryAlphaDataActionSuccess=(BMStatSummaryAlphaData)=>({
  type: FETCH_BMSTATSUMMARYALPHA_DATA_SUCCESS,
  payload:{BMStatSummaryAlphaData}
})

const getStatSummaryUpCaptureDataActionSuccess=(BMStatSummaryUpCaptureData)=>({
  type: FETCH_BMSTATSUMMARYUPCAPTURE_DATA_SUCCESS,
  payload:{BMStatSummaryUpCaptureData}
})

const getStatSummaryDownCaptureDataActionSuccess=(BMStatSummaryDownCaptureData)=>({
  type: FETCH_BMSTATSUMMARYDOWNCAPTURE_DATA_SUCCESS,
  payload:{BMStatSummaryDownCaptureData}
})

const getStatSummaryUpDownCaptureDataActionSuccess=(BMStatSummaryUpDownCaptureData)=>({
  type: FETCH_BMSTATSUMMARYUPDOWNCAPTURE_DATA_SUCCESS,
  payload:{BMStatSummaryUpDownCaptureData}
})

const tabFailure={
  0:getStatSummaryRorDataActionSuccess({}),
  1:getStatSummaryStdDevDataActionSuccess({}),
  2:getStatSummarySharpeDataActionSuccess({}),
  3:getStatSummarySortinoDataActionSuccess({}),
  4:getStatSummaryMaxDrawdownDataActionSuccess({}),
  5:getStatSummaryCorrelationDataActionSuccess({}),
  6:getStatSummaryBetaDataActionSuccess({}),
  7:getStatSummaryAlphaDataActionSuccess({}),
  8:getStatSummaryUpCaptureDataActionSuccess({}),
  9:getStatSummaryDownCaptureDataActionSuccess({}),
  10:getStatSummaryUpDownCaptureDataActionSuccess({}),
}

const getStatSummaryDataActionFailure=(error)=>({
  type: FETCH_STATSUMMARY_DATA_FAILURE,
  payload:{error}
})

export const getBMDDHistoryDataAction=(entityId, entityType, startDate, endDate, opt)=>{ 
  return async (dispatch) => {
    dispatch(getBMDDHistoryDataActionBegin());
    sbaAxios({url:`${getDDHistoryVsBM}${entityId},${entityType},${startDate},${endDate},${opt}`,method:'get'})
    .then(response=>{
      const BMDDHistoryData = response;
      dispatch(getBMDDHistoryDataActionSuccess(BMDDHistoryData));
    })
    .catch(error=>{
      if (error) {
        dispatch(getBMDDHistoryDataActionSuccess({}));
      } 
    });
  };
}

const getBMDDHistoryDataActionBegin=()=>({
  type: FETCH_BMDDHistory_DATA_BEGIN
})

const getBMDDHistoryDataActionSuccess=(BMDDHistoryData)=>({
  type: FETCH_BMDDHistory_DATA_SUCCESS,
  payload:{BMDDHistoryData}
})

const getBMDDHistoryDataActionFailure=(error)=>({
  type: FETCH_BMDDHistory_DATA_FAILURE,
  payload:{error}
})


export const getCumulativeChart=(AssetId, entityType, startDate, endDate, radioValue)=>{ 
  return async (dispatch) => {
    dispatch(getCumulativeChartBegin());
    sbaAxios({url:`${getCumulativeReturnsChart}${AssetId},${entityType },${startDate},${endDate},${radioValue}`,method:'get'})
    .then(response=>{
      const chartData = response;
      dispatch(getCumulativeChartSuccess(chartData));
    })
    .catch(error=>{
      if (error) {
        dispatch(getCumulativeChartSuccess({}));
      } 
    })
  };
}
const getCumulativeChartBegin=()=>(
  {
    type: FETCH_CUMMCHART_DATA_BEGIN,
    payload:{}
  }
)
const  getCumulativeChartSuccess=(chartData)=>(
  {
    type: FETCH_CUMMCHART_DATA_SUCCESS,
    payload:{chartData}
  }
)
const getCumulativeChartFailure=(error)=>(
  {
    type: FETCH_CUMMCHART_DATA_FAILURE,
    payload:{error}
  }
)


export const getVamiChartData=(AssetId, entityType, startDate, endDate, radioValue)=>{ 
  return async (dispatch) => {
    dispatch(getVamiChartDataBegin());
    sbaAxios({url:`${getreturnschart}${AssetId},${entityType},${startDate},${endDate},${radioValue}`,method:'get'})
    .then(response=>{
      const chartData = response;
      dispatch(getVamiChartDataSuccess(chartData));
    })
    .catch(error=>{
      if (error) {
        dispatch(getVamiChartDataSuccess({}));
      } 
    });
  };
}
const getVamiChartDataBegin=()=>(
  {
    type:FETCH_VAMICHART_DATA_BEGIN,
    payload:{}
  }
)
const  getVamiChartDataSuccess=(chartData)=>(
  {
    type: FETCH_VAMICHART_DATA_SUCCESS,
    payload:{chartData}
  }
)
const getVamiChartDataFailure=(error)=>(
  {
    type: FETCH_VAMICHART_DATA_FAILURE,
    payload:{error}
  }
)

export const getRollingChartData=(AssetId, entityType,isBM1Id, isBM2Id, periodValue)=>{ 
  return async (dispatch) => {
    dispatch(getRollingChartDataBegin());
    const period = periodValue?periodValue:36;
    sbaAxios({url:`${getRollingExcessReturns}${AssetId},${entityType},${period},${isBM1Id}~${isBM2Id}`,method:'get'})
    .then(response=>{
      const chartData = response;
      dispatch(getRollingChartDataSuccess(chartData));
    })
    .catch(error=>{
      if (error) {
        dispatch(getRollingChartDataFailure(error));
      } 
    });
  };
}
const getRollingChartDataBegin=()=>(
  {
    type:FETCH_ROLLINGCHART_DATA_BEGIN,
    payload:{}
  }
)
const  getRollingChartDataSuccess=(chartData)=>(
  {
    type: FETCH_ROLLINGCHART_DATA_SUCCESS,
    payload:{chartData}
  }
)
const getRollingChartDataFailure=(error)=>(
  {
    type: FETCH_ROLLINGCHART_DATA_FAILURE,
    payload:{error}
  }
)


export const getDistReturnsChartData=(AssetId, entityType, startDate, endDate, radioValue)=>{ 
  return async (dispatch) => {
    dispatch(getDISTRChartDataBegin());
    sbaAxios({url:`${getDistReturnsChart}${AssetId},${entityType},${startDate},${endDate},${radioValue}`,method:'get'})
    .then(response=>{
      const chartData = response;
      dispatch(getDISTRChartDataSuccess(chartData));
    })
    .catch(error=>{
      if (error) {
        dispatch(getDISTRChartDataSuccess({}));
      } 
    });
  };
}
const getDISTRChartDataBegin=()=>(
  {
    type:FETCH_DISTRCHART_DATA_BEGIN,
    payload:{}
  }
)
const  getDISTRChartDataSuccess=(chartData)=>(
  {
    type: FETCH_DISTRCHART_DATA_SUCCESS,
    payload:{chartData}
  }
)
const getDISTRChartDataFailure=(error)=>(
  {
    type: FETCH_DISTRCHART_DATA_FAILURE,
    payload:{error}
  }
)
